import { Shape, styled } from '@teko/ds-mobile';
import { ProductCarousel } from '@teko/teko-ecommerce';
import { ProductCardProps } from '@teko/types/ecommerce';
import { LazyComponent } from 'components/LazyComponent';
import { isServerless } from 'helpers';
import { useTenantConfig } from 'hooks';
import { SlotComponentProps } from 'modules/page-builder/types';
import React from 'react';
import { useProductsWrapper } from '../hooks/usePbProducts';

const DEFAULT_MAX_WIDTH = 1232;

enum ScreenSize {
  s = 1296,
  m = 1440,
  l = 1680,
}
export type ProductCarouselSlotProps = SlotComponentProps<
  {
    products: ProductCardProps[];
  },
  {
    borderProductCard?: boolean;
    regionName?: string;
    maxWidth?: number | string;
  }
>;

const ProductCarouselSlot: React.FC<ProductCarouselSlotProps> = ({
  collectionSlug,
  serverData,
  config = {},
}: ProductCarouselSlotProps) => {
  const { isMobile } = useTenantConfig();
  const { products } = useProductsWrapper(collectionSlug ?? '', serverData);

  return products?.length ? (
    <ProductCarousel
      products={products}
      productsPerRow={isMobile ? 2.3 : 5}
      border={config?.borderProductCard}
      regionName={config?.regionName}
    />
  ) : null;
};

export const LazyProductCarouselSlot: React.FC<ProductCarouselSlotProps> = (
  props,
) => {
  return (
    <LazyComponent>
      <ProductCarouselSlot {...props} />
    </LazyComponent>
  );
};

const NewLayoutProductCarouselSlot: React.FC<ProductCarouselSlotProps> = ({
  collectionSlug,
  serverData,
  config = {},
}: ProductCarouselSlotProps) => {
  const { isMobile } = useTenantConfig();
  const { products } = useProductsWrapper(collectionSlug ?? '', serverData);

  const productsPerRow = isMobile
    ? 2.3
    : Number(config?.maxWidth) <= DEFAULT_MAX_WIDTH || !isServerless()
    ? 5
    : window.innerWidth >= ScreenSize.l
    ? 6.5
    : window.innerWidth >= ScreenSize.m
    ? 5.5
    : window.innerWidth >= ScreenSize.s
    ? 5
    : 4.5;

  return products?.length ? (
    <Wrapper>
      <ProductCarousel
        products={products}
        productsPerRow={productsPerRow}
        border={config?.borderProductCard}
        regionName={config?.regionName}
        desktopProps={{ perSwipe: '', bound: true }}
      />
    </Wrapper>
  ) : null;
};

export const LazyNewLayoutProductCarouselSlot: React.FC<
  ProductCarouselSlotProps
> = (props) => {
  return (
    <LazyComponent>
      <NewLayoutProductCarouselSlot {...props} />
    </LazyComponent>
  );
};

const Wrapper = styled(Shape)`
  .horizontal-slider,
  .glide__track {
    background-color: white;
    border-radius: 12px;
  }
  .glide__arrow--left {
    left: 1px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
    &:after {
      height: 24px !important;
      width: 24px !important;
    }
  }
  .glide__arrow--right {
    right: 2px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
    &:after {
      height: 24px !important;
      width: 24px !important;
    }
  }
`;
